import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling (mandatory premium feel).
export default function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (new URLSearchParams(window.location.search).has("nolenis")) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const settle = () => {
    const top = el.getBoundingClientRect().top;
    if (Math.abs(top + 20) > 40) {
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20, duration: 0.6 });
      else window.scrollTo({ top: window.scrollY + top - 20, behavior: "auto" });
    }
  };
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20, duration: 1.4, onComplete: settle });
  else {
    el.scrollIntoView({ behavior: "smooth" });
    setTimeout(settle, 900);
  }
}
